export enum ProcedureConstants {
  SET_ASSESSED_BY_OPTIONS = 'procedure/SET_ASSESSED_BY_OPTIONS',
  SET_INPUT_ROWS = 'procedure/SET_INPUT_ROWS',
  SET_AUTHORIZATION_OPTIONS = 'procedure/SET_AUTHORIZATION_OPTIONS',
  SET_RESPONSE_OPTIONS = 'procedure/SET_RESPONSE_OPTIONS',
  SET_COMPLICATIONS_OPTIONS = 'procedure/SET_COMPLICATIONS_OPTIONS',
  SET_ROLE_PERFORMING_OPTIONS = 'procedure/SET_ROLE_PERFORMING_OPTIONS',
  SET_IS_FIRST_VISIT = 'procedure/SET_IS_FIRST_VISIT',
  SET_NEMSIS_CODE_OPTIONS = 'procedure/SET_NEMSIS_CODE_OPTIONS',
  NUMBER_PAD = 'numberPad',
  SINGLE_SELECT = 'singleSelect',
  TEXT = 'text',
  TEXTAREA = 'textArea',
  MULTI_SELECT = 'multiSelect',
  TIMES_ROW = 'timesRow',
  TOGGLE = 'toggle',
  DATE = 'date',
}
